
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [
  { field: "WORKORDER", label: "Work Order", align: "left" },
  { field: "PRIMECOST_LABOUR", label: "Prime Labour", align: "right" },
  { field: "PRIMECOST_STORES", label: "Prime Stores", align: "right" },
   { field: "PRIMECOST_MISC", label: "", align: "right" },
  { field: "ONCOST_LABOUR", label: "On Cost Labour", align: "right" },
  { field: "ONCOST_STORES", label: "On Cost Stores", align: "right" },
  { field: "PROFORMA", label: "Proforma", align: "right" },
  { field: "PROFIT", label: "Profit", align: "right" },
  { field: "SUP_STORES", label: "SUP Stores", align: "right" },
  { field: "FREIGHT", label: "Freight", align: "right" },
  { field: "INCENTIVE", label: "Incentive", align: "right" },
];

export default function WGRTable({ rows }) {
  return (
    <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align={column.align}
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                  whiteSpace: "nowrap",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              hover
              sx={{
                "&:nth-of-type(even)": {
                  bgcolor: "grey.50",
                },
              }}
            >
              <TableCell>
                {row.WORKORDER}
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.PRIMECOST_LABOUR}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.PRIMECOST_STORES}
                />
              </TableCell>

             <TableCell align="right">
  {typeof row.PRIMECOST_MISC === "number" ? (
    <CurrencyCell value={row.PRIMECOST_MISC} />
  ) : (
    <Typography
      variant="caption"
      color="error"
      sx={{ fontSize: 11 }}
    >
      {row.PRIMECOST_MISC}
    </Typography>
  )}
</TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.ONCOST_LABOUR}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.ONCOST_STORES}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.PROFORMA}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.PROFIT}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.SUP_STORES}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.FREIGHT}
                />
              </TableCell>

              <TableCell align="right">
                <CurrencyCell
                  value={row.INCENTIVE}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

